function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
// Compiler result to JSON file
import { createComponent } from 'js/declViewModelService';
import { registerDynImportEntry } from 'js/moduleLoader';
import AwParseService from 'js/awParseService';
import AwFilterService from 'js/awFilterService';
import { getField } from 'js/utils';
import { Fragment } from 'react';
let filterSer = AwFilterService.instance;
import AwFlexRow from 'viewmodel/AwFlexRowViewModel';
import AwSplmTable from 'viewmodel/AwSplmTableViewModel';
import AwImage from 'viewmodel/AwImageViewModel';
import AwLink from 'viewmodel/AwLinkViewModel';
import { EnableWhen } from 'js/hocCollection';
const AwLinkEnableWhen = EnableWhen(AwLink);
AwLinkEnableWhen.displayName = 'AwLinkEnableWhen';

/*
ctx imports
*/

const ctxImportObj = {};

/*
dynamic import
 */
registerDynImportEntry('js/appCtxService', () => import('js/appCtxService'));
registerDynImportEntry('js/rfqHelper', () => import('js/rfqHelper'));
registerDynImportEntry('js/accHttpService', () => import('js/accHttpService'));
registerDynImportEntry('js/accEventBus', () => import('js/accEventBus'));
;

/*
view model
 */
const declViewModelJson = {
  "schemaVersion": "1.0.0",
  "actions": {
    "addContentExistToCtx": {
      "actionType": "JSFunction",
      "method": "updateCtx",
      "deps": "js/appCtxService",
      "inputData": {
        "name": "contentExist",
        "value": true
      }
    },
    "performPostAddContentBatchAction": {
      "actionType": "batchJob",
      "steps": [{
        "action": "showTable"
      }, {
        "action": "refreshContentsTable"
      }]
    },
    "publishAddContentEvent": {
      "actionType": "JSFunction",
      "method": "publishEvent",
      "inputData": {
        "eventName": "add-content-event"
      },
      "deps": "js/rfqHelper"
    },
    "showTable": {
      "actionType": "JSFunction",
      "method": "showHideTable",
      "inputData": {
        "divId": "listRfqContentTableDiv",
        "totalFound": "1"
      },
      "deps": "js/rfqHelper"
    },
    "showHideTable": {
      "actionType": "JSFunction",
      "method": "showHideTable",
      "inputData": {
        "divId": "listRfqContentTableDiv",
        "totalFound": "{{data.totalFound}}"
      },
      "deps": "js/rfqHelper"
    },
    "getRfqContents": {
      "actionType": "JSFunctionAsync",
      "method": "createHttpRequest",
      "inputData": {
        "request": {
          "method": "POST",
          "url": "/acc/orchestrate",
          "withCredentials": true,
          "data": {
            "appBaseUrl": "assets",
            "additionalProperties": {},
            "query": "query getRfqContents( $collaborationspaceId: String, $rfqId: String, $rfqQuoteId: String, $skip: Int) { getRfqContents( collaborationspaceId: $collaborationspaceId, rfqId: $rfqId, rfqQuoteId: $rfqQuoteId, skip: $skip) { items totalCount skip}}",
            "variables": {
              "collaborationspaceId": "{{props.collaborationspaceid}}",
              "rfqId": "{{props.rfqid}}",
              "rfqQuoteId": "{{props.rfqquoteid}}",
              "skip": "{{data.RfqContentsSkip}}"
            }
          }
        },
        "progressIndicatorPrefix": "collab",
        "accSessionId": "{{props.accsessionid}}"
      },
      "dataParsers": [{
        "id": "rfqContentsParser",
        "responseObjs": "data.data.getRfqContents.items"
      }],
      "outputData": {
        "filterResults": "data.data.getRfqContents.items",
        "totalFound": "data.data.getRfqContents.totalCount",
        "error": "data.data.getRfqContents.error"
      },
      "actionMessages": {},
      "events": {
        "success": [{
          "condition": "error === null || error === undefined",
          "name": "list-rfq-contents-as-list.success"
        }, {
          "condition": "totalFound > 0",
          "name": "list-rfq-contents-as-list.contentExist"
        }, {
          "condition": "error === 'EMPTY_COLLAB_SPACE'",
          "name": "list-rfq-contents.error",
          "eventData": {
            "error": "{{i18n.EMPTY_COLLAB_SPACE}}",
            "errorCode": 400
          }
        }, {
          "condition": "error.statusCode === 400 || errorCode === 400",
          "name": "list-rfq-contents.error",
          "eventData": {
            "error": "{{error}}",
            "errorCode": 400
          }
        }, {
          "condition": "error.statusCode === 403 || errorCode === 403",
          "name": "list-rfq-contents.error",
          "eventData": {
            "error": "{{i18n.FORBIDDEN}}",
            "errorCode": 403
          }
        }, {
          "condition": "error.statusCode === 401 || errorCode === 401 || errorCode === 'INVALID_ACC_SESSION_ID'",
          "name": "list-rfq-contents.error",
          "eventData": {
            "error": "{{i18n.UNAUTHORIZED}}",
            "errorCode": 401
          }
        }, {
          "condition": "error.statusCode >= 500 && error.statusCode <= 599",
          "name": "list-rfq-contents.error",
          "eventData": {
            "error": "{{i18n.ACC_SERVER_ERROR}}",
            "errorCode": 500
          }
        }],
        "failure": [{
          "name": "list-rfq-contents.error",
          "eventData": {
            "error": "{{i18n.ACC_SERVER_ERROR}}",
            "errorCode": 500
          }
        }]
      },
      "deps": "js/accHttpService"
    },
    "removeRfqContents": {
      "actionType": "JSFunctionAsync",
      "method": "createHttpRequest",
      "inputData": {
        "request": {
          "method": "POST",
          "url": "/acc/orchestrate",
          "withCredentials": true,
          "data": {
            "appBaseUrl": "assets",
            "additionalProperties": {},
            "query": "mutation removeRfqContents( $collaborationspaceId: String, $rfqId: String, $urns: String, $domainName: String) { removeRfqContents( collaborationspaceId: $collaborationspaceId, rfqId: $rfqId, urns: $urns, domainName: $domainName) }",
            "variables": {
              "collaborationspaceId": "{{ctx.rfq.collaborationspaceid || props.collaborationspaceid}}",
              "rfqId": "{{ctx.rfq.rfqid || props.rfqid}}",
              "urns": "{{ctx.selectedRfqContentUrns}}",
              "domainName": "{{ctx.selectedDomainName}}"
            }
          }
        },
        "progressIndicatorPrefix": "collab",
        "accSessionId": "{{ctx.rfq.accsessionid || props.accsessionid}}"
      },
      "outputData": {
        "response": "data.data.removeRfqContents",
        "errorCode": "errorCode"
      },
      "events": {
        "success": [{
          "condition": "response.error === undefined",
          "name": "remove-rfq-contents.success",
          "eventData": {
            "response": "{{response}}"
          }
        }, {
          "condition": "response.error === 'EMPTY_COLLAB_SPACE'",
          "name": "remove-rfq-contents.error",
          "eventData": {
            "error": "{{i18n.EMPTY_COLLAB_SPACE}}",
            "errorCode": 400
          }
        }, {
          "condition": "response.error.statusCode === 400 || errorCode === 400",
          "name": "remove-rfq-contents.error",
          "eventData": {
            "error": "{{response.error}}"
          }
        }, {
          "condition": "response.error.statusCode === 403 || errorCode === 403",
          "name": "remove-rfq-contents.error",
          "eventData": {
            "error": "{{i18n.FORBIDDEN}}",
            "errorCode": 403
          }
        }, {
          "condition": "response.error.statusCode === 401 || errorCode === 401 || errorCode === 'INVALID_ACC_SESSION_ID'",
          "name": "remove-rfq-contents.error",
          "eventData": {
            "error": "{{i18n.UNAUTHORIZED}}",
            "errorCode": 401
          }
        }, {
          "condition": "response.error.statusCode >= 500 && response.error.statusCode <= 599",
          "name": "remove-rfq-contents.error",
          "eventData": {
            "error": "{{i18n.ACC_SERVER_ERROR}}",
            "errorCode": 500
          }
        }],
        "failure": [{
          "name": "remove-rfq-contents.error",
          "eventData": {
            "error": "{{i18n.ACC_SERVER_ERROR}}",
            "errorCode": 500
          }
        }]
      },
      "deps": "js/accHttpService"
    },
    "refreshContentsTable": {
      "actionType": "dataProvider",
      "method": "exampleDataProvider"
    },
    "publishToACCEventBus": {
      "actionType": "JSFunction",
      "method": "publish",
      "inputData": {
        "eventId": "{{parameters.eventId}}",
        "eventData": "{{parameters.eventData}}"
      },
      "deps": "js/accEventBus"
    },
    "addSelectedRfqContentUrnsToCtx": {
      "actionType": "JSFunction",
      "method": "updateCtx",
      "deps": "js/appCtxService",
      "inputData": {
        "name": "selectedRfqContentUrns",
        "value": "{{parameters.eventData}}"
      }
    },
    "addSelectedDomainNameToCtx": {
      "actionType": "JSFunction",
      "method": "updateCtx",
      "deps": "js/appCtxService",
      "inputData": {
        "name": "selectedDomainName",
        "value": "{{parameters.eventData}}"
      }
    }
  },
  "props": {
    "accsessionid": {
      "type": "string"
    },
    "collaborationspaceid": {
      "type": "string"
    },
    "rfqid": {
      "type": "string"
    },
    "rfqquoteid": {
      "type": "string"
    }
  },
  "data": {
    "image1": {
      "dbValue": "/assets/image/typeProjectRequest48.svg"
    },
    "RfqContentsSkip": 0,
    "noRfqContentLink": {
      "displayName": "{{i18n.addContents}}",
      "type": "STRING",
      "isRequired": "false"
    }
  },
  "dataProviders": {
    "exampleDataProvider": {
      "action": "getRfqContents",
      "response": "{{data.filterResults}}",
      "totalFound": "{{data.totalFound}}",
      "selectionModelMode": "single",
      "inputData": {
        "selectionModel": "{{subPanelContext.selectionModel}}"
      }
    }
  },
  "columnProviders": {
    "exampleColumnProvider": {
      "frozenColumnIndex": 0,
      "columns": [{
        "name": "filename",
        "displayName": "{{i18n.filename}}",
        "minWidth": 200,
        "width": 200,
        "enableColumnMenu": false,
        "pinnedLeft": true
      }, {
        "name": "typename",
        "displayName": "{{i18n.typename}}",
        "minWidth": 200,
        "width": 200,
        "enableColumnMenu": false
      }, {
        "name": "createdby",
        "displayName": "{{i18n.createdby}}",
        "minWidth": 200,
        "width": 200,
        "enableColumnMenu": false
      }, {
        "name": "creationdate",
        "displayName": "{{i18n.creationDate}}",
        "minWidth": 200,
        "width": 200,
        "enableColumnMenu": false
      }, {
        "name": "filesize",
        "displayName": "{{i18n.filesize}}",
        "minWidth": 100,
        "width": 100,
        "enableColumnMenu": false
      }, {
        "name": "urn",
        "displayName": "{{i18n.urn}}",
        "minWidth": 100,
        "width": 100,
        "enableColumnMenu": false
      }, {
        "name": "domainName",
        "displayName": "{{i18n.domainName}}",
        "minWidth": 100,
        "width": 100,
        "enableColumnMenu": false
      }]
    }
  },
  "grids": {
    "listRfqContentTable": {
      "dataProvider": "exampleDataProvider",
      "columnProvider": "exampleColumnProvider",
      "addIconColumn": false,
      "gridOptions": {
        "enablePinning": true,
        "enableSorting": false
      }
    }
  },
  "functions": {
    "filterRows": {
      "functionName": "filterRows",
      "parameters": ["{{data.dataProviders.exampleDataProvider.startIndex}}", "{{data.pageSize}}"]
    }
  },
  "i18n": {
    "creationDate": ["RfqMessages"],
    "name": ["RfqMessages"],
    "addContents": ["RfqMessages"],
    "rfqContentEmpty": ["RfqMessages"],
    "filename": ["RfqMessages"],
    "filetype": ["RfqMessages"],
    "typename": ["RfqMessages"],
    "createdby": ["RfqMessages"],
    "downloadticket": ["RfqMessages"],
    "filesize": ["RfqMessages"],
    "ACC_SERVER_ERROR": ["errorMessages"],
    "EMPTY_COLLAB_SPACE": ["errorMessages"],
    "BAD_REQUEST_CREATE_RFQ": ["errorMessages"],
    "FORBIDDEN": ["errorMessages"],
    "UNAUTHORIZED": ["errorMessages"],
    "urn": ["RfqMessages"],
    "domainName": ["RfqMessages"]
  },
  "onEvent": [{
    "eventId": "list-rfq-contents-as-list.success",
    "action": "showHideTable",
    "cacheEventData": true
  }, {
    "eventId": "list-rfq-contents-as-list.contentExist",
    "action": "addContentExistToCtx",
    "cacheEventData": true
  }, {
    "eventId": "add-contents-rfq.contentAdded",
    "action": "addContentExistToCtx",
    "cacheEventData": true
  }, {
    "eventId": "add-contents-rfq.contentAdded",
    "action": "performPostAddContentBatchAction",
    "cacheEventData": true
  }, {
    "eventId": "list-rfq-contents.error",
    "action": "publishToACCEventBus",
    "inputArgs": {
      "eventId": "des-list-rfq-contents.error",
      "eventData": {
        "message": "{{eventData.error}}",
        "statusCode": "{{eventData.errorCode}}"
      }
    }
  }, {
    "eventId": "exampleDataProvider.selectionChangeEvent",
    "action": "publishToACCEventBus",
    "inputArgs": {
      "eventId": "des-list-rfq-contents.selected",
      "eventData": "{{eventData.selectedObjects[0].props.urn.dbValue}}"
    }
  }, {
    "eventId": "exampleDataProvider.selectionChangeEvent",
    "action": "addSelectedRfqContentUrnsToCtx",
    "inputArgs": {
      "eventData": "{{eventData.selectedObjects[0].props.urn.dbValue}}"
    }
  }, {
    "eventId": "exampleDataProvider.selectionChangeEvent",
    "action": "addSelectedDomainNameToCtx",
    "inputArgs": {
      "eventData": "{{eventData.selectedObjects[0].props.domainName.dbValue}}"
    }
  }, {
    "eventId": "removeRfqContentsEvent",
    "action": "removeRfqContents",
    "cacheEventData": true
  }, {
    "eventId": "remove-rfq-contents.success",
    "action": "getRfqContents",
    "cacheEventData": true
  }, {
    "eventId": "remove-rfq-contents.success",
    "action": "refreshContentsTable",
    "cacheEventData": true
  }, {
    "eventId": "remove-rfq-contents.error",
    "action": "publishToACCEventBus",
    "inputArgs": {
      "eventId": "des-remove-rfq-contents.error",
      "eventData": {
        "message": "{{eventData.error}}",
        "statusCode": "{{eventData.errorCode}}"
      }
    }
  }, {
    "eventId": "remove-rfq-contents.success",
    "message": "deleteRfqContentsSuccess"
  }],
  "messages": {
    "deleteRfqContentsSuccess": {
      "messageType": "INFO",
      "messageText": "RFQ Content is removed successfully."
    }
  },
  "dataParseDefinitions": {
    "rfqContentsParser": {
      "identifier": "{{response.filename}}",
      "typeIconURL": "http://localhost:4012/assets/images/typeShareFolder48.svg",
      "type": "RFQ",
      "props": {
        "filename": {
          "name": "{{i18n.filename}}",
          "displayName": "{{i18n.filename}}",
          "value": "{{response.filename}}",
          "displayValue": "{{response.filename}}",
          "type": "String"
        },
        "typename": {
          "name": "{{i18n.typename}}",
          "displayName": "{{i18n.typename}}",
          "value": "{{response.typename}}",
          "displayValue": "{{response.typename}}",
          "type": "String"
        },
        "createdby": {
          "name": "{{i18n.createdby}}",
          "displayName": "{{i18n.createdby}}",
          "value": "{{response.createdby}}",
          "displayValue": "{{response.createdby}}",
          "type": "String"
        },
        "creationdate": {
          "name": "{{i18n.creationDate}}",
          "displayName": "{{i18n.creationDate}}",
          "value": "{{response.creationdate}}",
          "displayValue": "{{response.creationdate}}",
          "type": "String"
        },
        "filesize": {
          "name": "{{i18n.filesize}}",
          "displayName": "{{i18n.filesize}}",
          "value": "{{response.filesize}}",
          "displayValue": "{{response.filesize}}",
          "type": "String"
        },
        "urn": {
          "name": "{{i18n.urn}}",
          "displayName": "{{i18n.urn}}",
          "value": "{{response.urn}}",
          "displayValue": "{{response.urn}}",
          "type": "String"
        },
        "domainName": {
          "name": "{{i18n.domainName}}",
          "displayName": "{{i18n.domainName}}",
          "value": "{{response.domainName}}",
          "displayValue": "{{response.domainName}}",
          "type": "String"
        }
      }
    }
  },
  "conditions": {
    "enableRfq": {
      "expression": "!(ctx.rfqStatus === 'Closed' || ctx.rfqStatus === 'Awarded' || ctx.rfqStatus === 'Expired')"
    }
  },
  "_viewModelId": "ListRfqContents",
  "_uniqueViewModelId": "ListRfqContents",
  "ctx": {
    "rfq": {
      "type": "object"
    },
    "selectedRfqContentUrns": {
      "type": "object"
    },
    "selectedDomainName": {
      "type": "object"
    },
    "rfqStatus": {
      "type": "object"
    }
  }
};

/*
<div id="listRfqContentTableDiv" class="rfqHidden">
    <aw-flex-row>
        <aw-splm-table gridid="listRfqContentTable"></aw-splm-table>
    </aw-flex-row>
</div>
<br>
<div id="listRfqContentTableDiv-empty" class="rfqEmptyPage">
    <br>
    <aw-image source="data.image1.dbValue" class="emptyImage"></aw-image>
    <br>
    <h2>{{i18n.rfqContentEmpty}}</h2>
    <br>
    <h3><aw-link  class="emptyLink" enable-when="conditions.enableRfq" prop="data.noRfqContentLink"
            action="publishAddContentEvent"></aw-link></h3>
</div>
*/
const renderFn = props => {
  let subPanelContext = props.subPanelContext;
  let {
    viewModel: {
      data,
      dataProviders,
      dispatch,
      conditions,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    },
    grids,
    ctx,
    actions,
    fields,
    messages,
    i18n,
    formProp,
    viewPath
  } = props;
  data = {
    ...data,
    dataProviders
  };
  if (subPanelContext && subPanelContext.fields) {
    fields = {
      ...fields,
      ...subPanelContext.fields
    };
  }
  let $index = null;
  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
    id: "listRfqContentTableDiv",
    className: "rfqHidden"
  }, /*#__PURE__*/React.createElement(AwFlexRow, null, /*#__PURE__*/React.createElement(AwSplmTable, grids.listRfqContentTable))), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("div", {
    id: "listRfqContentTableDiv-empty",
    className: "rfqEmptyPage"
  }, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(AwImage, {
    source: AwParseService.instance("data.image1.dbValue")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    }),
    className: "emptyImage"
  }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("h2", null, AwParseService.instance("i18n.rfqContentEmpty")({
    props,
    data,
    fields,
    dataProviders,
    ctx,
    i18n,
    actions,
    subPanelContext,
    viewPath,
    conditions,
    formProp,
    dispatch,
    selectionModels,
    editHandlers,
    chartProviders,
    ports
  })), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("h3", null, /*#__PURE__*/React.createElement(AwLinkEnableWhen, _extends({
    className: "emptyLink"
  }, getField("data.noRfqContentLink", fields, $index, null, null), {
    action: actions.publishAddContentEvent,
    enableWhen: AwParseService.instance("conditions.enableRfq")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    })
  })))));
};

/*
define component
*/
const Component = createComponent(declViewModelJson, renderFn, undefined, ctxImportObj);
export default Component;